import { defineStore } from 'pinia';

import { useSessionStorage } from '@vueuse/core';

export const useSessionStore = defineStore('session', {
  state: () => ({
    checkout: useSessionStorage('checkout', {} as any),
    lockPromise: Promise.resolve(),
  }),
  actions: {
    // Lock the store and return a promise that resolves when the lock is released
    lock() {
      let unlock;
      this.lockPromise = new Promise((resolve) => {
        unlock = resolve;
      });
      return unlock;
    },
    // Wait for the lock to be released
    async waitForUnlock() {
      await this.lockPromise;
    },
    // Overwrites the entire states key with the new value
    async set({ key, value }: { key: string; value: any }) {
      if (!key) return;
      if (this.$state[key]?._disabled) return;
      this.$state[key] = value;
    },
    // Updates the state key with the new value
    async update({ key, value }: { key: string; value: any }) {
      // Note: This is probably the only function that needs to lock the store because it reads and then writes the state
      await this.waitForUnlock();
      const unlock = this.lock();
      if (!key) return;
      if (this.$state[key]?._disabled) return;
      this.$state[key] = { ...this.$state[key], ...value };
      unlock();
    },
    // Removes the state key
    remove({ key }: { key: string }) {
      if (!key) return;
      if (this.$state[key]?._disabled) return;
      delete this.$state[key];
    },
    // Empties the state key
    clear(key: string) {
      if (!key) return;
      if (this.$state[key]?._disabled) return;
      this.$state[key] = {};
    },
    // Empties the entire state
    clearAllSessions() {
      for (let key in this.$state) {
        if (this.$state[key]?._disabled) continue;
        this.$state[key] = {};
      }
    },
    // Disables the state key
    disable(key: string) {
      if (!key) return;
      this.$state[key] = { _disabled: true };
    },
    // Enables the state key
    enable(key: string) {
      if (!key) return;
      if (this.$state[key]?._disabled) this.$state[key] = {};
    },
  },
});
